export const SUBSCRIBE_PODCAST = 'SUBSCRIBE_PODCAST';
export const LOAD_LIBRARY = 'LOAD_LIBRARY';
export const LOAD_LIBRARY_FROM_FIREBASE = 'LOAD_LIBRARY_FROM_FIREBASE';
export const SELECT_PODCAST = 'SELECT_PODCAST';
export const SAVE_PODCASTS = 'SAVE_PODCASTS';
export const SAVE_PODCAST_EPISODES = 'SAVE_PODCAST_EPISODES';
export const SELECT_PODCAST_EPISODE = 'SELECT_PODCAST_EPISODE';
export const PLAY_PODCAST_EPISODES = 'PLAY_PODCAST_EPISODES';
export const PAUSE_PODCAST_EPISODES = 'PAUSE_PODCAST_EPISODES';

// Authentication flow actions
export const USER_IS_AUTHENTICATED = 'USER_IS_AUTHENTICATED';
export const CREATE_USER = 'CREATE_USER';
export const STORE_USER = 'STORE_USER';

// Error handler actions
export const THROW_ERROR = 'THROW_ERROR';
export const DISMISS_ERROR = 'DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/store/actions/actionTypes.js